import styled from 'styled-components';

export const ContactPageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.6rem;
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const TextBlock = styled.div`
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const MapBlock = styled.div`
  min-height: 260px;
`;

export const SocialLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const SocialLinkItem = styled.li`
  font-size: 0.9rem;
  margin-bottom: 4px;
`;
